import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, ViewChild } from '@angular/core';
import { PgFile, PgFileData, PgFileUtils } from '../../models/file.model';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-pg-file-preview',
    templateUrl: './pg-file-preview.component.html',
    styleUrls: ['./pg-file-preview.component.scss'],
    standalone: false
})
export class PgFilePreviewComponent implements OnChanges, OnDestroy {
    @Input() fileData:PgFileData|File|string;
    @Input() viewMode:string;

    @Output() success = new EventEmitter<void>();
    @Output() error = new EventEmitter<void>();

    file:PgFile = null;

    isLoaded = false;
    hasError = false;

    info:{
        path: string,
        size: string
    } = null;

    private _revokeUrl = false;

    private _checkRevokeUrl() {
        if(this._revokeUrl) {
            this._revokeUrl = false;
            URL.revokeObjectURL(this.file.url)
        }
    }

    constructor(private modalService:NgbModal) { }

    ngOnChanges() {
        this._checkRevokeUrl();

        this.isLoaded = false;
        this.hasError = false;

        if(typeof this.fileData == 'string') {
            let _name = this.fileData.replace(/^.*\//, '')

            this.file = new PgFile({
                nome: _name,
                nome_file: _name,
                url: this.fileData
            });
        }
        else if(this.fileData instanceof File) {
            this._revokeUrl = true;

            let _cFileData = new PgFileData();
            
            _cFileData.nome = this.fileData.name;
            _cFileData.nome_file = this.fileData.name;
            let _cType = this.fileData.type.split('/')[0];

            if(_cType == 'image' || _cType == 'audio' || _cType == 'video') {
                _cFileData.type = _cType + 's' as any;
            }
            else {
                let _cExtension = '';

                let _cExtensionMatch = _cFileData.nome_file.match(/\.[^\.]*$/);

                if(_cExtensionMatch != null) {
                    _cExtension = _cExtensionMatch[0].substr(1).toLowerCase();
                } 

                if(PgFileUtils.getCategoryExtensions('documents').indexOf(_cExtension) != -1) {
                    _cFileData.type = 'documents'
                }
            }

            _cFileData.url = URL.createObjectURL(this.fileData);

            this.info = {
                path: this.fileData.webkitRelativePath,
                size: PgFileUtils.getFileSizeString(this.fileData.size)
            }
 
            this.file = new PgFile(_cFileData);
        }
        else {
            this.file = new PgFile(this.fileData);
        }
    }

    ngOnDestroy() {
        this._checkRevokeUrl();
    }

    getView() {
        if(this.file == null || this.file.url == null) return null;
        else if(['images','audios','videos'].indexOf(this.viewMode) != -1) return this.viewMode;
        else return 'files'
    }

    getAuthorSourceLicense() {
        let _retVal = '';

        if(this.file.author) {
            _retVal = this.file.author;
        }

        if(this.file.source) {
            let _source = this.file.source;
            if(/^http/.test(_source)) {
                let _domain = _source.replace(/^.*\//, '').replace(/\/.*$/, '')
                _source = '<a target="_blank" href="' + _source + '">' + _domain + '</a>'
            }

            if(_retVal != '') _retVal += ' - '
            _retVal += _source;
        }

        if(this.file.license) {
            if(_retVal != '') _retVal += ' - '
            _retVal += this.file.license;
        }

        return _retVal;
    }

    onLoadSuccess() {
        this.isLoaded = true;
        this.success.emit()
    }

    onLoadError() {
        this.isLoaded = true;
        this.hasError = true;
        this.error.emit()
    }

    getMediaPreviewClass() {
        if(!this.isLoaded) return 'PGFilePreview-Display-Media--NotLoaded'
        else if(this.hasError) return 'PGFilePreview-Display-Media--Error'
        else return 'PGFilePreview-Display-Media--Success'
    }

    getFileSmallPreview() {
        if(this.file.type != null && this.file.type != 'documents') return this.file.type;
    }

    @ViewChild('previewModal') previewModal:ElementRef
    
    private _previewModalRef:NgbModalRef = null;

    previewMode = null;
    isLoadingPreview = false

    openPreviewModal(mode:string) {
        this.previewMode = mode;
        this.isLoadingPreview = true;
        this._previewModalRef = this.modalService.open(this.previewModal, { size: 'xl' })
    }

    previewModalDismiss() {
        this._previewModalRef.dismiss()
    }
}
